import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbItem } from '../models/breadcrumb-item';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  public breadcrumbs$ = new BehaviorSubject<BreadcrumbItem[]>([]);
  public isVisible$ = new BehaviorSubject<boolean>(true);
  public areAllVisible$ = new BehaviorSubject<boolean>(true);

  constructor() {}

  public add(breadcrumb: BreadcrumbItem) {
    const breadcrumbs = this.breadcrumbs$.value;
    breadcrumbs.push(breadcrumb);
    this.breadcrumbs$.next(breadcrumbs);
  }

  public remove(breadcrumb: BreadcrumbItem) {
    const breadcrumbs = this.breadcrumbs$.value.filter((item) => item.name !== breadcrumb.name);
    this.breadcrumbs$.next(breadcrumbs);
  }

  public show() {
    this.isVisible$.next(true);
  }

  public hide() {
    this.isVisible$.next(false);
  }

  public showAll() {
    this.areAllVisible$.next(true);
  }

  public hideAll() {
    this.areAllVisible$.next(false);
  }
}
